import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { DeliveryScheduleModalPage } from './delivery-schedule-modal.page';

const routes: Routes = [
  {
    path: '',
    component: DeliveryScheduleModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [DeliveryScheduleModalPage]
})
export class DeliveryScheduleModalPageModule {}
